// src/components/PlanBadge.js
"use client";
import React from "react";
import { Chip, Tooltip } from "@mui/material";

export default function PlanBadge({ plan, size="small" }) {
  const label = (plan || "FREE").toUpperCase();
  const color =
    label === "PLATINUM" ? "secondary" :
    label === "PREMIUM"  ? "primary"   : "default";
  const variant = label === "FREE" ? "outlined" : "filled";
  return (
    <Tooltip title={`Your plan: ${label}`}>
      <Chip size={size} color={color} variant={variant} label={label} />
    </Tooltip>
  );
}
